import { z } from 'zod'

import { filterDateTimeTypeSchema } from '../misc/timeframe.ts'
import { filterTypes } from '../query/filterTypes.ts'
import { nodePropertyNameSchema } from './common.ts'
import { viewConfigDimensionSchema } from './dimension.ts'

const viewConfigFilterCommonSchema = z.object({
  filterType: z.enum(filterTypes),
  filterValue: z.unknown().optional(),
  filterValueLabel: z.string().optional(), // valueがID値の時に、表示上はラベルの値を表示する目的で使う。compileの際は一切使わない想定
  // eslint-disable-next-line sonarjs/todo-tag
  filterValueParameterName: z.string().optional(), // 固定のvalueを指定する代わりに、実行時に可変なパラメーターを指定することも可能 // TODO: validation
  filterDateTimeType: filterDateTimeTypeSchema.optional(),
})

export const viewConfigPropertyFilterSchema = viewConfigFilterCommonSchema.extend({
  type: z.literal(`property`),
  property: nodePropertyNameSchema,
  option: z
    .object({
      shouldFilterToReferencedEntityName: z.boolean().optional(), // propertyがreferenceToを持っており、かつこれがtrueの時は、参照先のオブジェクトのname要素に対してフィルターを行う
      shouldConsiderCase: z.boolean().optional(), // valueが文字列の場合に、大文字と小文字を区別するかどうか。これがtrueの時は、大文字と小文字を区別する
    })
    .optional(),
})
export type ViewConfigPropertyFilter = z.infer<typeof viewConfigPropertyFilterSchema>

export const viewConfigFieldFilterSchema = viewConfigFilterCommonSchema.extend({
  type: z.literal(`field`),
  fieldName: z.string(),
})
export type ViewConfigFieldFilter = z.infer<typeof viewConfigFieldFilterSchema>

export const viewConfigDimensionFilterSchema = viewConfigFilterCommonSchema.extend({
  type: z.literal(`dimension`),
  dimension: viewConfigDimensionSchema,
  option: z
    .object({
      isDrillDownFilter: z.boolean().optional(), // ドリルダウンで付与されたフィルターかどうか
    })
    .optional(),
})
export type ViewConfigDimensionFilter = z.infer<typeof viewConfigDimensionFilterSchema>

export const viewConfigCustomFilterSchema = viewConfigFilterCommonSchema.partial().extend({
  type: z.literal(`custom`),
  label: z.string().optional(),
  filterValue: z.string(), // 任意のSQLを指定する。
})
export type ViewConfigCustomFilter = z.infer<typeof viewConfigCustomFilterSchema>

export const viewConfigFilterSchema = z.union([
  viewConfigPropertyFilterSchema,
  viewConfigFieldFilterSchema,
  viewConfigDimensionFilterSchema,
  viewConfigCustomFilterSchema,
])
export type ViewConfigFilter = z.infer<typeof viewConfigFilterSchema>

export const viewConfigFilterNodeSchema = z.object({
  logicalOperator: z.enum(['and', 'or']),
  leafs: viewConfigFilterSchema.array(),
  get children() {
    return viewConfigFilterNodeSchema.array()
  },
})
export type ViewConfigFilterNode = z.infer<typeof viewConfigFilterNodeSchema>

export const viewConfigFilterNodeForJoinOnSchema = z.object({
  // フィルタで"高度なフィルタ条件"をONにした場合、'or'の指定が可能になる
  logicalOperator: z.enum(['and', 'or']),
  leafs: viewConfigPropertyFilterSchema.array(),
  get children() {
    return viewConfigFilterNodeForJoinOnSchema.array()
  },
})
export type ViewConfigFilterNodeForJoinOn = z.infer<typeof viewConfigFilterNodeForJoinOnSchema>
